import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  company: string;
  jobTitle: string;
  companyError: string;
  industriesOfInterest1: string[],
  industriesYouWorkIn: string[],
  industriesOfInterest2: string[],
  searchIndustriesYouWorkIn: string,
  searchIndustriesOfInterest2: string,
  searchIndustriesOfInterest1: string,
  vbcToggle: boolean,
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class CustomisableUserProfilesScreenController extends BlockComponent<
  Props,
  S,
  SS
> {
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
    ];

    this.state = {
      company: "",
      jobTitle: "",
      companyError: "This field can't be empty",
      industriesOfInterest1: [],
      industriesYouWorkIn: [],
      industriesOfInterest2: [],
      searchIndustriesYouWorkIn: "",
      searchIndustriesOfInterest2: "",
      searchIndustriesOfInterest1: "",
      vbcToggle: false,
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  handleSearchIndustriesOfInterest1Change = (value: string) => {
    this.setState({
      searchIndustriesOfInterest1: value
    });
  }

  handleSearchIndustriesOfInterest2Change = (value: string) => {
    this.setState({
      searchIndustriesOfInterest2: value
    });
  }

  handleSearchIndustriesYouWorkInChange = (value: string) => {
    this.setState({
      searchIndustriesYouWorkIn: value
    });
  }

  handleCompanyChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const company = e.target.value;
  this.setState({
    company,
    companyError: company.trim() === "" ? "This field can't be empty" : ""
  })
}

handleJobTitleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
this.setState({
  jobTitle: e.target.value
})
}

handleIndustrySelect = (industry: string) => {
  this.setState(prevState => ({
    industriesOfInterest1: prevState.industriesOfInterest1.includes(industry)
      ? prevState.industriesOfInterest1.filter(i => i !== industry)
      : [...prevState.industriesOfInterest1, industry]
  }));
}

handleIndustriesYouWorkInSelect = (industry: string) => {
  this.setState(prevState => ({
    industriesYouWorkIn: prevState.industriesYouWorkIn.includes(industry)
      ? prevState.industriesYouWorkIn.filter(i => i !== industry)
      : [...prevState.industriesYouWorkIn, industry]
  }));
}

handleIndustriesOfInterest2Select = (industry: string) => {
  this.setState(prevState => ({
    industriesOfInterest2: prevState.industriesOfInterest2.includes(industry)
      ? prevState.industriesOfInterest2.filter(i => i !== industry)
      : [...prevState.industriesOfInterest2, industry]
  }));
}
handleBackClick = () => {
    this.props.navigation.navigate('CustomisableUserProfiles');
  }

  // Customizable Area End
}
